import { render, staticRenderFns } from "./PageObjectsPage.vue?vue&type=template&id=7d306974"
import script from "./PageObjectsPage.vue?vue&type=script&lang=js"
export * from "./PageObjectsPage.vue?vue&type=script&lang=js"
import style0 from "./PageObjectsPage.vue?vue&type=style&index=0&id=7d306974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports